import React from "react";
import { Phone, MapPin, Clock, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function OurServiceArea() {
  return <section data-section-id="223271" id="our-service-area" className="bg-card text-foreground py-14 md:py-20 lg:py-24 border-b border-border">
      <div className="container mx-auto w-full max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          {/* Left Column: Scope & Area */}
          <div className="lg:col-span-6 space-y-4">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif font-normal text-foreground">
              Where we work
            </h2>
            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
              We take on residential and commercial jobs in Dumfries, Virginia and the surrounding area.
            </p>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Whether you need remodelling, flooring, carpentry, painting, or repairs, we come out to your site, review the scope, and give you an honest schedule and estimate.
            </p>

            <div className="pt-2 flex flex-wrap gap-3">
              <Button asChild className="rounded h-11 px-6 text-sm font-sans font-medium">
                <Link to="/BookAppointmentPage">Book a visit</Link>
              </Button>
              <Button asChild variant="outline" className="rounded h-11 px-6 text-sm font-sans font-medium border-border hover:bg-muted">
                <a href="tel:+15712496482">
                  <Phone className="size-4 mr-2 text-primary" />
                  Call (571) 249-6482
                </a>
              </Button>
            </div>
          </div>

          {/* Right Column: Definition List */}
          <div className="lg:col-span-6 border border-border rounded p-6 sm:p-8 bg-background">
            <h3 className="text-lg font-serif font-normal text-foreground mb-4 pb-3 border-b border-border">
              Contact &amp; location
            </h3>

            <dl className="space-y-4 text-sm">
              <div className="flex items-start gap-3">
                <MapPin className="size-4 text-primary shrink-0 mt-0.5" />
                <div className="flex-1">
                  <dt className="text-xs font-mono uppercase tracking-widest text-muted-foreground">Address</dt>
                  <dd className="text-foreground mt-0.5">
                    17669 Avenel Lane, Dumfries, Virginia 22026
                  </dd>
                </div>
              </div>

              <div className="border-t border-border pt-3 flex items-start gap-3">
                <Phone className="size-4 text-primary shrink-0 mt-0.5" />
                <div className="flex-1">
                  <dt className="text-xs font-mono uppercase tracking-widest text-muted-foreground">Phone</dt>
                  <dd className="mt-0.5">
                    <a href="tel:+15712496482" className="text-foreground hover:text-primary transition-colors font-medium">
                      +1 (571) 249-6482
                    </a>
                  </dd>
                </div>
              </div>

              <div className="border-t border-border pt-3 flex items-start gap-3">
                <Clock className="size-4 text-primary shrink-0 mt-0.5" />
                <div className="flex-1">
                  <dt className="text-xs font-mono uppercase tracking-widest text-muted-foreground">Hours</dt>
                  <dd className="text-foreground mt-0.5">
                    Mon-Sat, 7am - 7pm
                  </dd>
                </div>
              </div>

              <div className="border-t border-border pt-3 flex items-start gap-3">
                <Mail className="size-4 text-primary shrink-0 mt-0.5" />
                <div className="flex-1">
                  <dt className="text-xs font-mono uppercase tracking-widest text-muted-foreground">Email</dt>
                  <dd className="mt-0.5">
                    <a href="mailto:princeowusu989@yahoo.com" className="text-foreground hover:text-primary transition-colors break-all">
                      princeowusu989@yahoo.com
                    </a>
                  </dd>
                </div>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>;
}